// @flow
import window from 'window';
import postscribeScript from 'postscribe-script';

export class PostscribeJsBundle {
	static push = (path: string, done: () => any): Promise => {
		return postscribeScript(path, {
			done,
		});
	};

	static exists = (url: string): boolean => {
		return Boolean(window.document.querySelectorAll(`script[src="${url}"]`).length);
	};
}